import PropTypes from "prop-types";

const Checkbox = ({ value, onChange, name, id }) => {
    return <input type='checkbox' checked={value} onChange={onChange} name={name} id={id} />;
};

Checkbox.propTypes = {
    value: PropTypes.any,
    onChange: PropTypes.func,
    name: PropTypes.string,
    id: PropTypes.string,
};
export default Checkbox;
